<template>
	<div
		:class="['panel', 'corporate-stages',
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.appearance? block.appearance : ''
		]"
	>
		<div class="container">
			<div
				v-if="isHeaderVisible"
				:class="[
					'panel_header',
					isBrand? 'sk' : '',
				]"
			>
				<div class="row">
					<div class="col-12">
						<h2>{{ block.block_title }}</h2>
					</div>
				</div>
			</div>

			<div class="corporate-stages-menu">
				<div v-swiper:menuSwiper="options">
					<div class="swiper-wrapper">
						<div
							v-for="(item, index) in block.items"
							:key="index"
							class="swiper-slide"
						>
							<button
								:class="[
									'stage',
									index === activeTabIndex? 'active' : '',
								]"
								@click="activeTabIndex = index"
							>
								<span v-if="item.title" class="digit">{{ item.title }}</span>
								<div v-if="item.description" class="description">
									{{ item.description }}
								</div>
							</button>
						</div>
					</div>
				</div>
			</div>

			<div class="corporate-stages-accordion">
				<b-collapse
					v-for="(item, index) in block.items"
					:id="'stage_accordion-'+index"
					:key="index"
					:visible="activeTabIndex === index"
					accordion="stages-accordion"
					role="tabpanel"
				>
					<div v-if="item.text_left && item.text_right" class="stage-pane">
						<div class="row">
							<div class="col-12 col-lg-6">
								<p class="title">
									{{ item.title_secondary }}
								</p>
								<div class="description" v-html="item.text_left" />
							</div>
							<div class="col-12 col-lg-6">
								<div
									class="description"
									v-html="item.text_right"
								/>
							</div>
						</div>
					</div>

					<div v-else class="stage-pane">
						<p v-if="item.title_secondary" class="title">
							{{ item.title_secondary }}
						</p>
						<div
							v-if="item.text_left"
							class="description"
							v-html="item.text_left"
						/>
					</div>
				</b-collapse>
			</div>

			<div v-if="isFooterVisible" class="panel_footer mt-4">
				<dynamic-button
					:button="block.button"
					:block-id="block.id"
					:scenario="block.scenario"
				/>
				<!--<panel-footer v-else :block="block"/>-->
			</div>
		</div>
	</div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import panel from '~/mixins/panel';

export default {
	name: 'PanelAdvantage01',
	components: {
		Swiper,
		SwiperSlide,
	},
	directives: {
		swiper: directive,
	},
	mixins: [panel],
	data() {
		return {
			activeTabIndex: 0,
			options: {
				slidesPerView: 'auto',
				spaceBetween: 0,
				// initialSlide: 0,
				// cssMode: true,
				// freeMode: true,
				loop: false,
			},
		};
	},
};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/home/panel-corporate-stages";
</style>

<style lang="scss">
	.stage-pane {

		ol {
			display: block;
			list-style: none;
			margin: 0 -0.75rem 0;
			padding: 0;
			font-size: 0;
			counter-reset: section;

			li {
				width: 50%;
				display: inline-block;
				position: relative;
				margin: -1px 0 1.5rem 0;
				padding: 0 0.75rem;
				vertical-align: top;

				font-size: 1.5rem;
				font-weight: bold;

				&::before {
					display: block;
					font-size: 4rem;
					line-height: 3rem;
					padding-top: 1rem;
					margin-bottom: 1rem;
					font-weight: normal;

					counter-increment: section;
					content: counter(section);
				}

				&::after {
					content: '';
					display: block;
					position: absolute;
					top: 0;
					left: 0.75rem;
					right: 0.75rem;
					border-top: 1px solid;
				}

				&:nth-child(1) {
					&::after {
						display: none;
					}
					&::before {
						padding-top: 0;
					}
				}
				&:nth-child(2) {
					&::after {
						display: none;
					}
					&::before {
						padding-top: 0;
					}
				}

				// @include media-breakpoint-up(sm) {

				// }
			}
		}
	}
</style>
